
export interface WithdrawMoneyRequest {
    lenderId: string;
    withdrawalRequests: Array<WithdrawalRequest>;
}

export interface WithdrawalRequest {
    productCode: string;
    withdrawalAmount: number;
    status: string,
    type: string,
    createdAt: string,
    updatedAt: string,
    _id: string,
    lenderId: string,
    requestId: string,
}

export enum WithdrawalRequestStatus {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED'
}

export enum WithdrawalRequestType {
    NORMAL = 'NORMAL',
    BALANCING = 'BALANCING',
}